/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateDataAccessGroup } from '../models/CreateDataAccessGroup';
import type { DataAccessGroup } from '../models/DataAccessGroup';
import type { DataAccessGroupSort } from '../models/DataAccessGroupSort';
import type { PaymarketListResponseItem } from '../models/PaymarketListResponseItem';
import type { UpdateDataAccessGroup } from '../models/UpdateDataAccessGroup';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class DataAccessGroupService {

    /**
     * Get list of data access groups
     * @returns DataAccessGroup Success
     * @throws ApiError
     */
    public static getDataAccessGroups({
        limit,
        offset,
        search,
        planIds,
        sort,
    }: {
        /**
         * Pagination Limit
         */
        limit?: number,
        /**
         * Pagination Offset
         */
        offset?: number,
        search?: string,
        planIds?: Array<number>,
        /**
         * Sorting options
         */
        sort?: DataAccessGroupSort,
    }): CancelablePromise<Array<DataAccessGroup>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dataAccessGroup',
            query: {
                'limit': limit,
                'offset': offset,
                'search': search,
                'planIds': planIds,
                'sort': sort,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Create data access group
     * @returns any Success
     * @throws ApiError
     */
    public static createDataAccessGroup({
        requestBody,
    }: {
        requestBody: CreateDataAccessGroup,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dataAccessGroup',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }

    /**
     * update data access group
     * @returns any Success
     * @throws ApiError
     */
    public static updateDataAccessGroup({
        id,
        requestBody,
    }: {
        id: number,
        requestBody: UpdateDataAccessGroup,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/dataAccessGroup/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Delete data access group
     * @returns any Success
     * @throws ApiError
     */
    public static deleteDataAccessGroup({
        id,
    }: {
        id: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/dataAccessGroup/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Returns the list of paymarkets data access groups
     * @returns PaymarketListResponseItem Success
     * @throws ApiError
     */
    public static getPayMarkets({
        limit,
        offset,
        plan,
        paymarketGroup,
        ungrouped,
    }: {
        /**
         * Pagination Limit
         */
        limit?: number,
        /**
         * Pagination Offset
         */
        offset?: number,
        /**
         * Plan ID
         */
        plan?: number,
        /**
         * Paymarket group ID
         */
        paymarketGroup?: number,
        /**
         * Filter for all ungrouped paymarkets
         */
        ungrouped?: boolean,
    }): CancelablePromise<Array<PaymarketListResponseItem>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dataAccessGroup/paymarket',
            query: {
                'limit': limit,
                'offset': offset,
                'plan': plan,
                'paymarketGroup': paymarketGroup,
                'ungrouped': ungrouped,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

}
